import "whatwg-fetch";
import { stringify } from "qs";

function doFetch(url, options) {
  return new Promise((fulfillFetch, rejectFetch) => {
    // TODO: remove once old static login is deprecated
    // force cookies to be sent to server
    const opts = { ...options, credentials: "include" };

    fetch(url, opts)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }

        /**
         * @param {object} object
         * @param {number} statusCode
         */
        const attachStatusCode = (object, statusCode) => {
          if (typeof object === "object" && typeof object.statusCode === "undefined") {
            // eslint-disable-next-line no-param-reassign
            object.statusCode = statusCode;
          }

          return object;
        };

        return new Promise((fulfill, reject) => {
          response
            .json()
            .then(json => {
              reject(attachStatusCode(json, response.status));
            })
            .catch(error => reject(attachStatusCode(error, response.status)));
        });
      })
      .then(json => {
        if (json.error || json.validation) {
          rejectFetch(json);

          return;
        }

        fulfillFetch(json);
      })
      .catch(rejectFetch);
  });
}

function buildUrl(path, query, absolute = false) {
  let url;

  if (absolute) {
    url = path;
  } else {
    url = `/api${path}`;
  }

  if (query) {
    url += `?${stringify(query)}`;
  }

  return url;
}

export default {
  get(path, query, absolute = false) {
    const url = buildUrl(path, query, absolute);

    const promise = doFetch(url);

    // allow clients to detect if promises are the same
    promise.path = path;

    return promise;
  },
  delete(path, absolute = false) {
    const url = buildUrl(path, null, absolute);

    const options = {
      method: "DELETE",
    };

    return doFetch(url, options);
  },
  post(path, data, absolute = false) {
    const url = buildUrl(path, null, absolute);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    return doFetch(url, options);
  },
  // This should be refactored to be with POST
  postFormData(path, data, absolute = false) {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      formData.set(key, data[key]);
    });

    const url = buildUrl(path, null, absolute);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    };

    return doFetch(url, options);
  },
  put(path, data, absolute = false) {
    const url = buildUrl(path, null, absolute);
    const options = {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    return doFetch(url, options);
  },
};
